// Application-managed enum for the `status` column on `EmailHistory`.
//
// Previously this was a Postgres enum (`public.email_status`) generated into
// `prisma-generated`. The DB column is now a plain TEXT column so this enum
// is the single source of truth for valid values.
//
// This file must stay dependency-free: the send-email lambda bundles it.
export enum email_status {
  Not_Processed = "Not_Processed",
  Failed = "Failed",
  Sent = "Sent",
  Opted_Out = "Opted_Out",
  Processed = "Processed",
  Lambda_Error = "Lambda_Error",
}
